import { render, staticRenderFns } from "./SlotsPage.vue?vue&type=template&id=01fb3c7b&scoped=true&lang=pug"
import script from "./SlotsPage.vue?vue&type=script&lang=js"
export * from "./SlotsPage.vue?vue&type=script&lang=js"
import style0 from "./SlotsPage.vue?vue&type=style&index=0&id=01fb3c7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fb3c7b",
  null
  
)

export default component.exports